<template>
  <div id="app">
    <!--<img src="./assets/logo.png">-->
    <div v-if="!notFound()" class="container">
      <Navigation></Navigation>
      <router-view></router-view>
    </div>
    <div v-if="notFound()" class="container">
      <NotFound></NotFound>
    </div>
  </div>
</template>

<script>
import Navigation from './components/Navigation'
import NotFound from './components/NotFound'
export default {
  name: 'App',
  components: {
    'Navigation': Navigation,
    'NotFound': NotFound
  },
  methods: {
    notFound () {
      let dataset = this.$route.params.dataset
      let result = (dataset === undefined)
      return result
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/App.vue